"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=getPushSubscription;function getPushSubscription(){var a=this;return new Promise(function(b,c){a.swRegistration?a.swRegistration.pushManager.getSubscription().then(function(c){a.pushSubscription=c,b(c)}):c(new Error("Service Worker registration unavailable. Please initialize."))})}


// WEBPACK FOOTER //
// ../q-push-notifications/lib/prototypes/getPushSubscription.js